import { push } from '@lagunovsky/redux-react-router'
import Container from 'react-bootstrap/Container'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'

import FormLayout from '../../components/Forms/FormLayout/FormLayout'
import Typography from '../../components/Typography/Typography'
import InfoWindow from '../../components/Windows/InfoWindow/InfoWindow'

import hocAuth from '../../services/auth/hocAuth'

import { useLocation } from 'react-router'
import useThanksPageGtmInfo from 'services/gtm/useThanksPageGtmInfo'
import './TicketsReserved.scss'
import hocTicketsReserved from './hocTicketsReserved'

const TicketsReserved = ({ isAuthorized, reservations }) => {
    const intl = useIntl()
    const dispatch = useDispatch()

    const { search } = useLocation()
    const params = new URLSearchParams(search)
    const paramsObject = Object.fromEntries(params)

    const bookingId = paramsObject?.bookingId
    const bookingNumber = paramsObject?.bookingNumber

    useThanksPageGtmInfo(bookingId, 'Rezervace')

    return (
        <Container fluid className={'tickets-reserved d-flex flex-column align-items-center'}>
            <Typography variant={'h1'} className={'me-auto'}>
                {intl.formatMessage({ id: 'ticketsReserved.title' }, { id: bookingNumber })}
            </Typography>
            <FormLayout color="purple" className={'tickets-reserved--layout d-flex w-100'}>
                <div className="tickets-reserved--img position-relative">
                    <img
                        src={'images/cinestar/tickets-blue.png'}
                        alt={'tickets-blue'}
                        className={'position-absolute'}
                    />
                </div>
                <div className="tickets-reserved--description d-flex flex-column">
                    <Typography variant={'h2'} className={'text-nowrap'}>
                        {intl.formatMessage({ id: 'thanksForOrder.subtitle3' })}
                    </Typography>
                    {isAuthorized && (
                        <Typography variant={'p'}>
                            {intl.formatMessage(
                                { id: 'thanksForOrder.findThem' },
                                {
                                    redirect: (chunks) => (
                                        <u
                                            role={'button'}
                                            className={'text-underline'}
                                            onClick={() => dispatch(push('/user-profile'))}
                                        >
                                            {chunks}
                                        </u>
                                    ),
                                }
                            )}
                        </Typography>
                    )}
                </div>
            </FormLayout>
            <InfoWindow
                color={'red'}
                title={intl.formatMessage({ id: 'windows.notification.title' })}
                description={intl.formatMessage({ id: 'windows.notification.ticketsReserved' })}
            />

            <img
                src={'images/cinestar/astronaut-with-mobile.png'}
                alt={'astronaut-with-mobile'}
                className={'astronaut-animate w-50 h-auto mt-10'}
            />
        </Container>
    )
}

export default hocTicketsReserved(hocAuth(TicketsReserved))
